const MAPBOX_TEXT_LAYER_IDS = [
  "country-label-lg",
  "country-label-md",
  "country-label-sm",
  "state-label-lg",
  "state-label-md",
  "state-label-sm",
  "marine-label-lg-pt",
  "marine-label-lg-ln",
  "marine-label-md-pt",
  "marine-label-md-ln",
  "marine-label-sm-pt",
  "marine-label-sm-ln",
  "place-city-lg-n",
  "place-city-lg-s",
  "place-city-md-n",
  "place-city-md-s",
  "place-city-sm",
  "place-islands-2",
  "place-islands",
  "place-town",
  "place-village",
  "place-hamlet",
  "place-suburb",
  "place-islets-archipelago-aboriginal-2",
  "place-islets-archipelago-aboriginal",
  "airport-label",
  "poi-scalerank1",
  "poi-parks-scalerank1",
  "water-label",
  "poi-parks-scalerank2",
  "poi-scalerank2",
  "road-label-large",
  "road-label-medium",
  "road-label-small",
  "poi-parks-scalerank3",
  "poi-scalerank3"
];

export default {
  data() {
    return {};
  },
  methods: {
    getBrowserLanguage() {
      let lang = window.navigator.language
      return lang.slice(0, 2)
    },
    getTextLayerIds() {
      return MAPBOX_TEXT_LAYER_IDS
    },
    getSupportedLanguages() {
      return require("@/i18n/languages.json").options
    },
    // async getCurrentMapLanguageSetting() {
    //   let res = await LocalDbService.getMapLanguage()
    //   // 表示言語設定がない場合はブラウザの言語設定を返す
    //   if(!res){
    //     let lang = this.getBrowserLanguage()
    //     await this.saveMapLanguageToLocalDb(lang)
    //     await this.saveMapLanguageToFireStore(lang)
    //     return lang
    //   }
    //   return res
    // },
    // async saveMapLanguageToLocalDb(language) {
    //   return await LocalDbService.saveMapLanguage(language)
    // },
    // async saveMapLanguageToFireStore(language) {
    //   return await FireStoreService.saveMapLanguage(language)
    // },
  }
};
